// const ghostQueryConfig = [
//     {
//         tag: `hash-faq`,
//         section: `faq`,
//         niceName: `FAQ`,
//         template: `./src/templates/ghost/faq.js`,
//         tagsTemplate: `./src/templates/ghost/faq-archive.js`,
//         indexName: `faq`,
//     },
//     {
//         tag: `hash-tutorial`,
//         section: `tutorials`,
//         niceName: `Tutorials`,
//         template: `./src/templates/ghost/tutorial.js`,
//         tagsTemplate: `./src/templates/ghost/tutorial-archive.js`,
//         indexName: `tutorial`,
//     },
//     {
//         tag: `hash-integration`,
//         section: `integrations`,
//         niceName: `Integrations`,
//         template: `./src/templates/ghost/integration.js`,
//         tagsTemplate: `./src/templates/ghost/integration-archive.js`,
//         indexName: `integration`,
//     },
// ]

const markdownQueryConfig = [
    {
        section: `concepts`,
        indexName: `concept`,
        niceName: `起步`,
    },
    {
        section: `ebooks_mba_market_marketing`,
        indexName: `ebook_mba_market_marketing`,
        niceName: `著作 - MBA轻松读 - 市场营销`,
    },
]

module.exports = {
    defaultMarkdownSection: `concept`,
    markdownQueryConfig,
    searchConfig: markdownQueryConfig
        .reduce((acc, { indexName, niceName }) => {
            acc[indexName] = niceName
            return acc
        }, {}),
}
